// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"ck","result_page":"ek","what_are_calories":"fk","title":"gk","copy":"hk","chart":"ik","to_reach":"jk","title_wrapper":"kk","rhode_percent":"lk","what_are_macro":"mk","text":"nk","img":"ok","macros_wrapper":"pk","macros":"qk","macro_item":"rk","value":"sk","note":"tk","btn":"uk","carbo_item":"vk","faq":"wk","faq_items":"xk"};
    if(module.hot) {
      // 1714422952419
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  